import {
    hideValidationMessage,
    showValidationMessage,
    emailValidation,
    phoneValidation,    
    specialCharValidation
  } from '../form-validation-message.js';

  import { codeTransactionData } from './country-code-istransactional-v2.js';
    
  const validatePhoneWithLength = (targetElement, countryCodeElement) => {
    if (!targetElement || !countryCodeElement) return false;
    const currentCode = countryCodeElement.value;
    const matched = codeTransactionData.find(obj => obj.code === currentCode);
    const val = targetElement.value.trim();

    if (matched && matched.phoneLength) {
        return val.length === matched.phoneLength && /^\d+$/.test(val);
    } else {
    return phoneValidation(targetElement);
    }
    };

    const globalReceiver = document.getElementById('rc-form')

    if(Boolean(globalReceiver)) {
        let receiverNameChangeFormObject = {};
        const mtcn = globalReceiver?.querySelector('#input-mtcn')
        const fname = globalReceiver?.querySelector('#input-fname')
        const mname = globalReceiver?.querySelector('#input-mname')
        const lname = globalReceiver?.querySelector('#input-lname')
        const mywuCardNo = globalReceiver?.querySelector('#input-mywu-card-num')
        const mailid = globalReceiver?.querySelector('#input-email')
        const code = globalReceiver?.querySelector('#input-country-code')
        const mobile = globalReceiver?.querySelector('#input-mobile-num')

        const driver_license = globalReceiver?.querySelector('#input-driver-license')
        const nat_id = globalReceiver?.querySelector('#input-state-nat-id')
        const passport = globalReceiver?.querySelector('#input-passport')
        const residence_card = globalReceiver?.querySelector('#input-perm-residence-card')
        const other_id = globalReceiver?.querySelector('#input-other-id')

        const r_fname = globalReceiver?.querySelector('#input-receiver-fname')
        const r_mname = globalReceiver?.querySelector('#input-receiver-mname')
        const r_lname = globalReceiver?.querySelector('#input-receiver-lname')

        const r_new_fname = globalReceiver?.querySelector('#input-receiver-new_fname')
        const r_new_mname = globalReceiver?.querySelector('#input-receiver-new_mname')
        const r_new_lname = globalReceiver?.querySelector('#input-receiver-new_lname')

        const overLayContainer = document.querySelector('#rc_responseModal');
        const closeOverlayButton = document.querySelector('.closeOverlayBtn');
        const openHelpCenterBtn = document.querySelector('.openHelpCenterBtn');

        const consentCheckBox = globalReceiver?.querySelector('#checkbox_agreement');
        const redirectUrl     = globalReceiver?.querySelector('#redirect_url');
        const additionalParam = globalReceiver?.querySelector('#additional_param');
        const additionalList  = (additionalParam?.value)?JSON.parse(atob(additionalParam.value)):''
        let humanKeyEL = globalReceiver.querySelector("#humanKey");
        
        const mandateList = [mtcn,fname,lname,mailid,mobile,r_fname,r_lname,r_new_fname,r_new_lname,humanKeyEL]
        
        Array.from(globalReceiver.elements).forEach((el) => {
            el.addEventListener('keyup', (e) => {
                if(e.target.tagName=='INPUT' && (e.target.name=='wu-input-number' && !validatePhoneWithLength(e.target, code)) || (e.target.type=='text' && e.target.name != 'wu-input-number' && specialCharValidation(e.target)) ||
                (e.target.type=='email' && !emailValidation(e.target))) {
                    showValidationMessage(e.target, 'error-msg')
                } else {
                    hideValidationMessage(e.target)
                }
            })
        })

        const openMessageOverlay = (caseNum)=> {
            overLayContainer?.classList?.add("d-block");
            overLayContainer?.classList?.remove("d-none")
            let caseNumbeEl =  document.querySelector("#caseNumbeEl");
            if(caseNumbeEl){
                caseNumbeEl.innerText = caseNum;
            }   
        }

        receiverNameChangeFormObject.openWuHelpCenter = function() {
            var win = window.open(redirectUrl.value,"_self");
            win.focus()
        }

        receiverNameChangeFormObject.resetCaptcha = function(){
            humanKeyEL.value="";
            if(grecaptcha){
              grecaptcha.reset();
            }
        }
    
        closeOverlayButton?.addEventListener('click',(event)=>{
            event.preventDefault();
            overLayContainer?.classList?.remove("d-block");
            overLayContainer?.classList?.add("d-none");
            receiverNameChangeFormObject.openWuHelpCenter()
        })

        openHelpCenterBtn.addEventListener('click',(event)=>{
            event.preventDefault();
            receiverNameChangeFormObject.openWuHelpCenter();
        })
        
        const triggerSubmitApi = async()=> {
            try {
                let serviceURl = "https://www3.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postNameChangeForm";
                if (window.location.hostname == 'www.westernunion.com') {
                  serviceURl = "https://www.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postNameChangeForm";
                }   
    
                let tempObject = {};
                tempObject["consent"] = consentCheckBox.checked;
                tempObject["humanKey"] = humanKeyEL.value;
                tempObject["suppliedEmail"] =mailid.value;
                tempObject["suppliedMTCN"] = mtcn.value;
                tempObject["suppliedSenderFirstName"] = fname.value;
                tempObject["suppliedSenderMiddleName"] = mname.value;
                tempObject["suppliedSenderLastName"] =lname.value;
                tempObject["suppliedMyWU"] =mywuCardNo.value;
                tempObject["suppliedPhone"] =`${code.value}-${mobile.value}`;
                tempObject["driverLicenceLabel"] =driver_license.value;
                tempObject["stateNationalId"] =nat_id.value;
                tempObject["passport"] = passport.value;
                tempObject["permanentResidenceCard"] =residence_card.value;
                tempObject["other"] =other_id.value;
                tempObject["suppliedReceiverFirstName"] =r_fname.value;
                tempObject["suppliedReceiverMiddleName"] =r_mname.value;
                tempObject["suppliedReceiverLastName"] =r_lname.value;
                tempObject = {...tempObject,...additionalList}
                // we need to combined id and udpated receiver name as an ID value
                var supplied_comments ="";
                var idData = {
                    id: []
                };
                const suppliedList = {"Driver License":driver_license,"State/National Id":nat_id,"Passport":passport,"Permanent Residence":residence_card,"Other":other_id,"New Receiver First Name":r_new_fname,"New Receiver Middle Name":r_new_mname,"New Receiver Last Name":r_new_lname}
                for (const data in suppliedList) {
                    let dataVal = suppliedList[data].value
                    idData.id.push({"idType": data,"idValue":dataVal });
                    if (dataVal != ''){   
                        supplied_comments = supplied_comments + data + ':' + dataVal+";";
                    } 
                };
                tempObject = { ...idData, ...tempObject};
                tempObject["suppliedComments"] = supplied_comments;
                console.log(tempObject);

                const requestOptions = {
                    method: "POST",
                    headers: {
                        "accept": "application/json",
                        "Content-Type": "application/json",
                        "accept-language": "en-US,en"
                    },
                    body: JSON.stringify(tempObject)
                };
                const apiResponse = await fetchApiWu(`${serviceURl}?timestamp=${new Date().getTime()}`, requestOptions, "receiverNameChange")
               
                console.log(apiResponse)
                handleReceiverChangeResponse(apiResponse)
            } catch(e){
                // Error handled silently for security
            }     
        }
    
        const handleReceiverChangeResponse = (apiResponse) => {
           
           if(apiResponse?.compositeResponse?.length > 1){
                let compositeResponse = apiResponse.compositeResponse[1];
                let caseNumber = (compositeResponse?.httpStatusCode=="200" && compositeResponse?.referenceId=="ref_case_query") ? compositeResponse?.body?.CaseNumber : "error" ;
                openMessageOverlay(caseNumber);
           }
           else{
                receiverNameChangeFormObject.resetCaptcha();
           }
        }


        globalReceiver?.addEventListener('submit', (event) => {
            event.preventDefault();
            let err = [];
            Array.from(globalReceiver.elements).forEach((el) => {
                if(mandateList.includes(el) && !el.value) {
                    showValidationMessage(el,'required-msg')
                    err.push(el)
                } else if(el.tagName=='INPUT' && (el.name=='wu-input-number' && !validatePhoneWithLength(el, code)) || (el.type=='text' && el.value && specialCharValidation(el)) || 
                (el.type=='email' && !emailValidation(el)) || (el.type=='checkbox' && consentCheckBox.checked==false)) {
                    showValidationMessage(el,'error-msg')
                    err.push(el)
                } else {
                    hideValidationMessage(el)
                }
            })

            if(err.length!=0) {
                let error_element = document.getElementById(err[0].id);
                error_element.scrollIntoView(); 
            } else {
                triggerSubmitApi();
            }
        })
    }
